import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {Thread} from '@github-ui/diff-lines/conversation-types'
import {useCompositeThreadPositioning} from '../../hooks/use-composite-thread-positioning'
import {useDiffEntries} from '../../stores/selectors'

function ThreadPositioningWithStore({threads}: {threads: Thread[]}) {
  useCompositeThreadPositioning(threads, useDiffEntries())
  return null
}

function ThreadPositioningServerOnly({threads}: {threads: Thread[]}) {
  useCompositeThreadPositioning(threads)
  return null
}

/**
 * Hydrates thread positioning for comments that fall outside the current diff.
 */
export function HydrateThreadPositioning({threads}: {threads: Thread[]}) {
  return isFeatureEnabled('updated_pull_request_header') ? (
    <ThreadPositioningServerOnly threads={threads} />
  ) : (
    <ThreadPositioningWithStore threads={threads} />
  )
}
